import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(10, 22, 40, 0.45);
  backdrop-filter: blur(6px);
`;

export const ModalShell = styled.div`
  width: 100%;
  max-width: 520px;
  max-height: 90vh;
  overflow: auto;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(13, 78, 254, 0.12);
  box-shadow: 0 20px 48px rgba(13, 78, 254, 0.18);
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 20px 0;
`;

export const ModalCloseButton = styled.button`
  border: none;
  background: #f3f4f6;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5a6478;
`;

export const ModalBody = styled.div`
  padding: 20px;

  .field-block {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 18px;
  }

  .field-label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #1a1a2e;
  }

  input,
  textarea {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 0.95rem;
    font-family: inherit;
    background: #f7fafc;

    &:focus {
      outline: none;
      border-color: #0d4efe;
      box-shadow: 0 0 0 3px rgba(13, 78, 254, 0.12);
    }

    &.has-error {
      border-color: #dc2626;
    }
  }

  .field-error {
    color: #dc2626;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .modal-config-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 18px;
  }

  .modal-config-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.8rem;
    font-weight: 700;
    color: #3a4050;
    letter-spacing: 0.2px;

    svg {
      color: #0d4efe;
      opacity: 0.65;
      flex-shrink: 0;
    }
  }

  .modal-config-hint {
    font-size: 0.74rem;
    color: #8a94a6;
    font-weight: 400;
    line-height: 1.4;
    margin-top: -4px;
  }

  .modal-price-type-options {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    @media (max-width: 400px) {
      grid-template-columns: 1fr;
    }
  }

  .modal-price-type-pill {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1.5px solid rgba(0, 0, 0, 0.08);
    background: #ffffff;
    cursor: pointer;
    font-family: inherit;
    text-align: left;
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      border-color: rgba(13, 78, 254, 0.2);
      background: rgba(13, 78, 254, 0.02);
    }

    &.active {
      border-color: #0d4efe;
      background: rgba(13, 78, 254, 0.05);
      box-shadow: 0 2px 8px rgba(13, 78, 254, 0.08);
    }

    .pill-label {
      font-size: 0.82rem;
      font-weight: 700;
      color: #1a1a2e;
      line-height: 1.3;
    }

    .pill-hint {
      font-size: 0.7rem;
      font-weight: 400;
      color: #8a94a6;
      line-height: 1.3;
    }

    &.active .pill-label {
      color: #0d4efe;
    }

    &.active .pill-hint {
      color: #6b8cfe;
    }
  }

  .modal-price-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 4px;
  }

  .modal-price-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 120px;
  }

  .modal-price-label {
    font-size: 0.7rem;
    font-weight: 600;
    color: #8a94a6;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .modal-price-input-wrap {
    display: flex;
    align-items: center;
    border: 1.5px solid rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;
    background: #ffffff;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:focus-within {
      border-color: #0d4efe;
      box-shadow: 0 0 0 3px rgba(13, 78, 254, 0.08);
    }

    &.error {
      border-color: rgba(220, 53, 69, 0.5);
      &:focus-within {
        box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.08);
      }
    }
  }

  .modal-price-prefix {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    font-size: 0.88rem;
    font-weight: 700;
    color: #8a94a6;
    background: #f7fafc;
    border-right: 1px solid rgba(0, 0, 0, 0.06);
    height: 40px;
  }

  .modal-price-input-wrap input {
    border: none;
    outline: none;
    padding: 9px 12px;
    font-family: inherit;
    font-size: 0.88rem;
    font-weight: 600;
    color: #1a1a2e;
    width: 100%;
    background: transparent;

    &::placeholder {
      color: #c0c7d2;
      font-weight: 500;
    }

    -moz-appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .modal-price-or {
    font-size: 0.78rem;
    font-weight: 600;
    color: #aab3c0;
    text-align: center;
    flex-shrink: 0;
    padding-top: 18px;
  }

  .modal-field-error {
    font-size: 0.72rem;
    font-weight: 600;
    color: #dc3545;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 2px;

    svg {
      flex-shrink: 0;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
`;

export const ModalFooterLeft = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const ModalFooterActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-shrink: 0;
`;

export const ModalSecondaryButton = styled.button`
  border: 1px solid rgba(13, 78, 254, 0.25);
  background: #fff;
  color: #1a1a2e;
  border-radius: 10px;
  padding: 10px 16px;
  cursor: pointer;
  font-weight: 600;
`;

export const ModalPrimaryButton = styled.button`
  border: none;
  background: linear-gradient(90deg, #01ebb2 0%, #0d4efe 100%);
  color: #fff;
  border-radius: 10px;
  padding: 10px 18px;
  cursor: pointer;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 4px 14px rgba(13, 78, 254, 0.35);

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
